import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, Stack, Typography, Table, TableHead, TableRow,
  TableCell, TableBody, Chip, Box,
} from '@mui/material'
import { Print } from '@mui/icons-material'
import { useQuery } from '@tanstack/react-query'
import { getCertificate, type StockStatus, type QcDecision } from '../../api/productieCalitate'

const STATUS_LABEL: Record<StockStatus, string> = { Liber: 'Liber', Blocat: 'Blocat', InControl: 'În control', Scrap: 'Rebut' }
const DECISION_COLOR: Record<QcDecision, 'success' | 'error' | 'warning' | 'info'> = {
  Acceptat: 'success', Respins: 'error', Rework: 'warning', Carantina: 'info',
}

export default function QualityCertificateDialog({ target, onClose }: { target: { articleId: string; lotNumber: string } | null; onClose: () => void }) {
  const open = target !== null
  const { data } = useQuery({
    queryKey: ['productie', 'calitate', 'certificat', target?.articleId, target?.lotNumber],
    queryFn: () => getCertificate(target!.articleId, target!.lotNumber), enabled: open,
  })

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <style>{'@media print { .no-print { display: none !important; } }'}</style>
      <DialogTitle>Certificat de calitate — lot {data?.lotNumber}</DialogTitle>
      <DialogContent>
        {data && (
          <Stack spacing={2}>
            <Box>
              <Typography variant="h6">{data.articleCode} — {data.articleDescription}</Typography>
              <Typography variant="body2" color="text.secondary">Lot: <code>{data.lotNumber}</code></Typography>
            </Box>

            <Typography variant="subtitle2">Sold curent pe status</Typography>
            <Table size="small">
              <TableHead><TableRow><TableCell>Status</TableCell><TableCell align="right">Cantitate (mii buc)</TableCell></TableRow></TableHead>
              <TableBody>
                {data.stockBalances.map((b) => (
                  <TableRow key={b.status}><TableCell>{STATUS_LABEL[b.status]}</TableCell><TableCell align="right">{b.quantity}</TableCell></TableRow>
                ))}
              </TableBody>
            </Table>

            <Typography variant="subtitle2">Inspecții (FR-OQC-001/002)</Typography>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Data</TableCell><TableCell>Punct</TableCell><TableCell align="right">Cantitate</TableCell>
                  <TableCell>Decizie</TableCell><TableCell>Neconformități</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data.inspections.map((i) => (
                  <TableRow key={i.id}>
                    <TableCell>{new Date(i.inspectedAt).toLocaleString('ro-RO')}</TableCell>
                    <TableCell>{i.checkpoint === 'ControlFinal' ? 'Control final' : 'Control în proces'}</TableCell>
                    <TableCell align="right">{i.quantityThousands}</TableCell>
                    <TableCell><Chip size="small" label={i.decision} color={DECISION_COLOR[i.decision]} variant="outlined" /></TableCell>
                    <TableCell>{i.nonconformities.length === 0 ? '—' : i.nonconformities.map((n) => n.nonconformityTypeCode).join(', ')}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Stack>
        )}
      </DialogContent>
      <DialogActions className="no-print" sx={{ px: 3, pb: 2.5 }}>
        <Button onClick={onClose}>Închide</Button>
        <Button variant="contained" startIcon={<Print />} onClick={() => window.print()}>Printează</Button>
      </DialogActions>
    </Dialog>
  )
}
